"use client";

import { ButtonProps } from "@chakra-ui/react";
import React from "react";
import { useTranslatedString } from "../../i18n/hooks";
import { URLModalButton } from "../URLModal/URLModalButton";

type PremiumCalcButtonProps = {
	productOrCategory?: string;
	categoryProduct?: string;
	enablePrefill?: boolean;
} & ButtonProps;

export const PremiumCalcButton: React.FC<PremiumCalcButtonProps> = ({
	productOrCategory,
	categoryProduct,
	children,
	enablePrefill = true,
	...rest
}) => {
	const t = useTranslatedString();

	const params = enablePrefill
		? {
				productOrCategory,
				categoryProduct,
			}
		: undefined;

	return (
		<URLModalButton
			data-testid="premium-calc-cta"
			modalName="PremiumCalc"
			params={params}
			{...rest}
		>
			{children ? children : t("premiumCalc.calculate")}
		</URLModalButton>
	);
};

// 🔬 TBD: Please evaluate
